import { py9 } from './styles.js';

var SELECT_OPTION_CONFIG = {
  large: {
    Checkbox: 'h-20 w-20',
    Icon: 'h-24 w-24',
    Root: 'py-12'
  },
  medium: {
    Checkbox: 'h-18 w-18',
    Icon: 'h-20 w-20',
    Root: py9
  }
};

export { SELECT_OPTION_CONFIG };
//# sourceMappingURL=consts.js.map
